import React, { useRef, useState, useEffect } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import "../styles/Faq.css";
import "../styles/Aerospace.css";
import TabTitle from "../components/TabTitle";
import MiningFaq from "./MiningFaq";
import DataSources from "../components/DataSources";

export default function Mining() {
  const [expanded, setExpanded] = useState(false);
  const navbarRef = useRef(null);

  // Close dropdown when clicking outside the navbar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div>
      <LandingSection
        data={{
          imageName: "mines.webp",
          title: "Mining",
        }}
      />
      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>
              Utah’s Mining Legacy: From Pioneer Ore to Modern Critical Minerals
            </h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              The mining industry in Utah has long served as a cornerstone of
              the state’s economy—mining operations today extract and process
              essential metals and industrial minerals such as copper,
              beryllium, magnesium, and lithium.
            </p>
          </div>
        </div>
      </div>
      <TabTitle />
      <MiningFaq />
      <DataSources
        sources={[
          "https://ledextract.ces.census.gov/qwi/all",
        ]}
      />
      <Footer />
    </div>
  );
}
